import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResolutionsSkeletonComponent } from './resolutions-skeleton.component';



@NgModule({
  declarations: [ResolutionsSkeletonComponent],
  imports: [
    CommonModule
  ],
  exports:[ResolutionsSkeletonComponent]

})
export class ResolutionsSkeletonModule { }
